import React from 'react';
import PageWrapper from './shared/pagewrapper/PageWrapper.js';
import Message from './shared/message/Message.js';

export default function PageNaoEncontrada() {
    return (
        <PageWrapper>
            <Message type='blank'>Página não encontrada ou sem permissão de acesso.</Message>
        </PageWrapper>
    );
}
